<template>
  <container-widget id="sell-others" title="Sell Others" typeBG="2">
    OTHERS
  </container-widget>
</template>

<script>
export default {

}
</script>

<style scoped>
#sell-others{
    height: 300px;
}
</style>